import { buildUrl } from '../../../../../../shared/frontend/libs/utils';
import { networkService } from '../../../../../../shared/frontend/scripts/services/networkService';

type NetworkBaseQueryArgs = {
  url: string;
  params?: Record<string, any>;
  method?: string;
  body?: any;
};

export const networkBaseQuery = async ({ url, params, method = 'GET', body }: NetworkBaseQueryArgs) => {
  try {
    const fullUrl = params ? buildUrl(url, params) : url;
    const verb = method.toUpperCase();
    let data;
    switch (verb) {
      case 'GET':
        data = await networkService.get(fullUrl);
        break;
      case 'PATCH':
        data = await networkService.patch(fullUrl, body);
        break;
      case 'PUT':
        data = await networkService.put(fullUrl, body);
        break;
      case 'DELETE':
        data = await networkService.delete(fullUrl, body);
        break;
      default:
        data = await networkService.post(fullUrl, body);
    }
    return { data };
  } catch (error) {
    return { error };
  }
};
